"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7349],{

/***/ 27719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AQ": function() { return /* binding */ addItemInCompareList; },
  "j9": function() { return /* binding */ createCompareList; },
  "C5": function() { return /* binding */ deleteItemFromComapreList; },
  "UU": function() { return /* binding */ getCompareList; }
});

// UNUSED EXPORTS: getCatelouge, getLocationDetail

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(31230);
;// CONCATENATED MODULE: ./gql/catalouge.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n{\n    download_catalogue {\n      area{\n          id\n          value\n      }\n      category{\n          id\n          value\n      }\n      areacollections{\n          area_id\n          area_name\n          categorycollection{\n              category_id\n              category_name\n              categorydata{\n                  url_key\n                  title\n                  image\n                  pdf\n              }\n          }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\nmutation ($productIds: [ID!]!) {\n    createCompareList(\n      input: {\n        products: $productIds\n      }\n    ) {\n      uid\n      item_count\n    }\n  }\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ($compareListUid: ID!, $productIds: [ID!]!) {\n    addProductsToCompareList(\n      input: {\n        uid: $compareListUid\n        products: $productIds\n      }\n    ) {\n      uid\n      item_count\n    }\n  }\n  \n    "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\nmutation ($compareListUid: ID!, $productIds: [ID!]!) {\n  removeProductsFromCompareList(\n    input: {\n      uid: $compareListUid\n      products: $productIds\n    }\n  ) {\n    uid\n    item_count\n    attributes {\n      code\n      label\n    }\n    items {\n      uid\n      product {\n        sku\n        name\n        description {\n          html\n        }\n      }\n    }\n  }\n}\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\nquery ($compareListUid: ID!) {\n  compareList(uid: $compareListUid) {\n    uid\n    item_count\n    attributes {\n      code\n      label\n    }\n    items {\n      uid\n      product {\n        id\n        name\n        sku\n        url_key\n        extraVariables{\n            image_url\n            product_url\n            tile_size\n            liquidation_sale\n            stock\n            plocation\n            category_ids\n           \n            \n\n            tile_design\n            tile_type\n            tile_area\n            colors\n            \n          finish{\n            label\n            value\n            url_key\n        }\n        type{\n          label\n          value\n          url_key\n      }\n            colors\n            rating_summary{\n                rating_count\n                avg_rating\n                avg_percentage\n            }\n            sq_mt_price\n            sq_ft_price\n            discounted_price\n            total_area_sq_ft\n        }\n        description {\n            html\n        }\n    }\n    }\n  }\n}\n\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "query P_location($pincode: Int!){\n  p_location(pincode : $pincode){\n    pincode\n    attribute_name\n    state\n    value\n  }\n}"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}

const catalouge_GET_CATELOUGE = (0,lib/* gql */.Ps)(_templateObject());
const CREATE_COMPARE_LIST = (0,lib/* gql */.Ps)(_templateObject1());
const ADD_ITEM_IN_COMPARE_LIST = (0,lib/* gql */.Ps)(_templateObject2());
const DELETE_ITEM_FROM_COMPARE_LIST = (0,lib/* gql */.Ps)(_templateObject3());
const GET_COMPARE_LIST = (0,lib/* gql */.Ps)(_templateObject4());
const catalouge_GET_PROLOCATION = (0,lib/* gql */.Ps)(_templateObject5());

// EXTERNAL MODULE: ./graphqlClient.js
var graphqlClient = __webpack_require__(33119);
;// CONCATENATED MODULE: ./api.services.js/catalouge.js


const getCatelouge = async (variables)=>{
    const options = {
        query: GET_CATELOUGE,
        variables: variables
    };
    try {
        const response = await client.query(options);
        return response;
    } catch (error) {
        return error;
    }
};
const getCompareList = async (variables)=>{
    const options = {
        query: GET_COMPARE_LIST,
        variables: variables
    };
    try {
        const response = await graphqlClient/* default.query */.Z.query(options);
        return response;
    } catch (error) {
        return error;
    }
};
const createCompareList = async (variables)=>{
    const options = {
        mutation: CREATE_COMPARE_LIST,
        variables: variables
    };
    try {
        const response = await graphqlClient/* default.mutate */.Z.mutate(options);
        return response;
    } catch (error) {
        return error;
    }
};
const addItemInCompareList = async (variables)=>{
    const options = {
        mutation: ADD_ITEM_IN_COMPARE_LIST,
        variables: variables
    };
    try {
        const response = await graphqlClient/* default.mutate */.Z.mutate(options);
        return response;
    } catch (error) {
        return error;
    }
};
const deleteItemFromComapreList = async (variables)=>{
    const options = {
        mutation: DELETE_ITEM_FROM_COMPARE_LIST,
        variables: variables
    };
    try {
        const response = await graphqlClient/* default.mutate */.Z.mutate(options);
        return response;
    } catch (error) {
        return error;
    }
};
const getLocationDetail = async (variables)=>{
    const options = {
        query: GET_PROLOCATION,
        variables: variables
    };
    try {
        const response = await client.query(options);
        return response;
    } catch (error) {
        return error;
    }
};


/***/ }),

/***/ 32147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6154);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6212);
/* harmony import */ var _loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62077);
/* harmony import */ var _crop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29005);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);








function VisualSearch(props) {
    const [openFilters, setOpenFilters] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const [loading, setloading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const [totalProds, settotalProds] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const [facets, setfacets] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [searchMetaData, setsearchMetaData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const [Products, setProducts] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [perPage, setperPage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [AppliedFacet, setAppliedFacet] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const [ApiUrl, setApiUrl] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [loadmore, setloadmore] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [SortBy, setSortBy] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("*");
    const [imgCropped, setImageCropped] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [ImageType, seImageType] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [ImageData, seImageData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [imageCrop, setImageCrop] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [imgSrc, setImgSrc] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(props.base64);
    const [imgB64, setImgB64] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [openMob, setOpenMob] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    function convertPricePerSqmToSqft(pricePerSqm) {
        const conversionFactor = 10.7639;
        return (pricePerSqm / conversionFactor).toFixed(0);
    }
    let loadMore = async ()=>{
        const result = {};
        let obj = {
            ...AppliedFacet
        };
        for (const [key, value] of Object.entries(obj)){
            if (value != null && value !== "") {
                result[key] = value;
            }
        }
        setAppliedFacet({
            ...result
        });
        const urlObj = new URL("https://search.unbxd.io//v2.0/sites/ss-unbxd-aapac-prod-orientbell53741713874410/images");
        Object.entries(result).forEach((param)=>{
            let [k, v] = param;
            const encodedFilter = "".concat(k, ':"').concat(v, '"');
            urlObj.searchParams.append("filter", encodedFilter);
        });
        urlObj.searchParams.append("rows", perPage + 9);
        // if(SortBy != "*"){
        // urlObj.searchParams.append('sort', `${SortBy}`);
        // }
        setperPage(perPage + 9);
        try {
            getVisualResult(urlObj.toString(), ImageType, ImageData);
        } catch (error) {
            console.log("error");
            swal("Something went wrong please try again later");
        }
    };
    let getResultwithFacet = async (key, value)=>{
        const result = {};
        let obj = {
            ...AppliedFacet,
            [key]: value
        };
        for (const [key1, value1] of Object.entries(obj)){
            if (value1 != null && value1 !== "") {
                result[key1] = value1;
            }
        }
        setAppliedFacet({
            ...result
        });
        const urlObj = new URL("https://search.unbxd.io//v2.0/sites/ss-unbxd-aapac-prod-orientbell53741713874410/images");
        Object.entries(result).forEach((param)=>{
            let [k, v] = param;
            const encodedFilter = "".concat(k, ':"').concat(v, '"');
            urlObj.searchParams.append("filter", encodedFilter);
        });
        urlObj.searchParams.append("rows", 9);
        setperPage(9);
        try {
            getVisualResult(urlObj.toString(), ImageType, ImageData);
        } catch (error) {
            console.log("error");
            swal("Something went wrong please try again later");
        }
    // console.log(urlObj.toString(), ImageType, ImageData);
    };
    let applysort = async (s)=>{
        const result = {};
        let obj = {
            ...AppliedFacet
        };
        for (const [key, value] of Object.entries(obj)){
            if (value != null && value !== "") {
                result[key] = value;
            }
        }
        setAppliedFacet({
            ...result
        });
        const urlObj = new URL("https://search.unbxd.io//v2.0/sites/ss-unbxd-aapac-prod-orientbell53741713874410/images");
        Object.entries(result).forEach((param)=>{
            let [k, v] = param;
            const encodedFilter = "".concat(k, ':"').concat(v, '"');
            urlObj.searchParams.append("filter", encodedFilter);
        });
        urlObj.searchParams.append("rows", perPage);
        setSortBy(s);
        if (s != "*") {
            urlObj.searchParams.append("sort", "".concat(s));
        }
        try {
            getVisualResult(urlObj.toString(), ImageType, ImageData);
        } catch (error) {
            console.log(error);
            swal("Something went wrong please try again later");
        }
    // console.log(urlObj.toString(), ImageType, ImageData);
    };
    const getVisualResult = async (APIUrl, typee, dataa)=>{
        setloading(true); // Set loading to true before the request
        const options = {
            method: "POST",
            url: APIUrl,
            headers: {
                // Check if 'typee' already includes 'base64', if not, append ';base64'
                "Content-Type": typee.includes("base64") ? typee : "".concat(typee, ";base64"),
                Authorization: "5a4b9251b67027ff94d260e4ac6ac09e"
            },
            data: dataa
        };
        (0,axios__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(options).then((response)=>{
            setloading(false); // Set loading to false after success
            // handle response data
            settotalProds(response.data.response.numberOfProducts);
            setProducts(response.data.response.products);
            setperPage(response.data.response.products.length);
            setsearchMetaData(response.data.searchMetaData);
            setfacets(response.data.facets.text.list);
        // console.log(response.data);
        }).catch((error)=>{
            setloading(false); // Set loading to false after error
        // console.log('Error:', error);
        });
    };
    // This useEffect handles the case when base64 image is provided and imgCropped is false
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (props.base64 && !imgCropped) {
            // Define the default MIME type for the image
            let mimeType = "image/jpeg"; // Adjust this based on your actual image type
            // Check if the base64 string already includes the MIME type and data prefix
            let base64String = props.base64;
            if (!props.base64.startsWith("data:")) {
                // If it's missing, manually add the MIME type and base64 prefix
                base64String = "data:".concat(mimeType, ";base64,").concat(props.base64);
            }
            // console.log("Formatted Base64 String: ", base64String);
            setImgSrc(base64String); // Set the formatted base64 string in state
            setImgB64(base64String);
            // Now split base64 string into type and actual base64 data
            let splitdata = base64String.split(",");
            // Extract image data and type for the API call
            seImageData(splitdata[1]); // Base64 data without the prefix
            seImageType(mimeType); // MIME type for the Content-Type header
            // Call the API with the MIME type and Base64 data
            getVisualResult("https://search.unbxd.io/v2.0/sites/ss-unbxd-aapac-prod-orientbell53741713874410/images", "".concat(mimeType), splitdata[1] // Base64 data without the prefix
            );
        }
    }, [
        props.base64,
        imgCropped
    ]); // Only depend on base64 and imgCropped
    // This useEffect handles the case when the image is cropped and imgCropped is true
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (imgCropped && imgSrc) {
            // Handle the cropped image case
            console.log("Cropped Image Source: ", imgSrc);
            let splitdata = imgSrc.split(",");
            // Ensure the MIME type and base64 data are handled correctly
            seImageData(splitdata[1]); // Base64 data without prefix
            seImageType(splitdata[0].split(":")[1]); // Extract MIME type
            // Call the API with cropped image data
            getVisualResult("https://search.unbxd.io/v2.0/sites/ss-unbxd-aapac-prod-orientbell53741713874410/images", splitdata[0].split(":")[1], splitdata[1] // Base64 data without the prefix
            );
        }
    }, [
        imgCropped,
        imgSrc
    ]); // Now imgCropped and imgSrc are the dependencies
    // Toggle the specific filter based on index
    const toggleFilter = (index)=>{
        setOpenFilters((prevState)=>({
                ...prevState,
                [index]: !prevState[index]
            }));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        class: "new-visual-search-modal",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            show: props.base64,
            onHide: ()=>props.setbase64content(false),
            className: "visual-modal",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Dialog */ .Z.Dialog, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Header */ .Z.Header, {
                        closeButton: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Body */ .Z.Body, {
                        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "loading-content",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    src: "/loader.gif",
                                    alt: "loader",
                                    width: "200",
                                    height: "200"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                    children: "Hold tight! Your awesome results are on their way..."
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: openMob ? "search-similar-product-sectio expanded-sec" : "search-similar-product-sectio ",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "search-similar-product-left",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "search-similarproduct-head",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                                children: "Shopping Matches"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "similarproduct-left-row-data",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "similarproduct-left-scroll-bx",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: !imageCrop ? "similarproduct-img crop-img-filter" : "similarproduct-img",
                                                        children: [
                                                            !imageCrop ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                src: imgSrc,
                                                                alt: "similar product"
                                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_crop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                imgSrc: imgB64,
                                                                setImgSrc: setImgSrc,
                                                                setImageCropped: setImageCropped
                                                            }),
                                                            !imageCrop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "crop-icon-section",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    src: "/icons8-crop-50.png",
                                                                    alt: "crop icon",
                                                                    onClick: ()=>setImageCrop(true)
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "similarproduct-filter",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "similarproduct-filter-mobile-heading",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                        children: "All Filters"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                        type: "button",
                                                                        class: "btn-close",
                                                                        "aria-label": "Close",
                                                                        onClick: ()=>setOpenMob(false)
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "similarproduct-filter-row",
                                                                children: Array.isArray(facets) && facets.map((face, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "similarproduct-filter-col",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: openFilters[index] ? "flt-type-heading open" : "flt-type-heading",
                                                                                onClick: ()=>toggleFilter(index),
                                                                                children: face.displayName
                                                                            }),
                                                                            openFilters[index] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                className: "flt-type-listing",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                                                        class: "ais-RefinementList-list",
                                                                                        children: loadmore.includes(face.displayName) && face.values.filter((f)=>typeof f != "number").length > 3 ? face.values.filter((f)=>typeof f != "number").map((cc)=>{
                                                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                                                class: "ais-RefinementList-item",
                                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                                                    class: "ais-RefinementList-label",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                                                            class: "ais-RefinementList-checkbox",
                                                                                                            type: "checkbox",
                                                                                                            onChange: (e)=>{
                                                                                                                if (e.target.checked) {
                                                                                                                    getResultwithFacet(face.facetName, cc);
                                                                                                                } else {
                                                                                                                    getResultwithFacet(face.facetName, "");
                                                                                                                }
                                                                                                            },
                                                                                                            checked: AppliedFacet[face.facetName] == cc
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                                            class: "ais-RefinementList-labelText",
                                                                                                            children: cc
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            });
                                                                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                                            children: [
                                                                                                face.values.filter((f)=>typeof f != "number").slice(0, 3).map((cc)=>{
                                                                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                                                        class: "ais-RefinementList-item",
                                                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                                                            class: "ais-RefinementList-label",
                                                                                                            children: [
                                                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                                                                    class: "ais-RefinementList-checkbox",
                                                                                                                    type: "checkbox",
                                                                                                                    onChange: (e)=>{
                                                                                                                        if (e.target.checked) {
                                                                                                                            getResultwithFacet(face.facetName, cc);
                                                                                                                        } else {
                                                                                                                            getResultwithFacet(face.facetName, "");
                                                                                                                        }
                                                                                                                    },
                                                                                                                    checked: AppliedFacet[face.facetName] == cc
                                                                                                                }),
                                                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                                                    class: "ais-RefinementList-labelText",
                                                                                                                    children: cc
                                                                                                                })
                                                                                                            ]
                                                                                                        })
                                                                                                    });
                                                                                                }),
                                                                                                face.values.filter((f)=>typeof f != "number").length > 3 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                                    className: "load-more-btn",
                                                                                                    onClick: ()=>{
                                                                                                        setloadmore([
                                                                                                            ...loadmore,
                                                                                                            face.displayName
                                                                                                        ]);
                                                                                                    },
                                                                                                    style: {
                                                                                                        color: "blue",
                                                                                                        marginBottom: "0px !important"
                                                                                                    },
                                                                                                    children: "load more"
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {})
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }, index))
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "search-similar-product-right",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "search-similarproduct-head",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "similarproduct-select",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
                                                        class: "select-bx",
                                                        value: SortBy,
                                                        onChange: (e)=>{
                                                            applysort(e.target.value);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                value: "*",
                                                                children: "Relevance"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                value: "price desc",
                                                                children: "Price (high to low)"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                value: "price asc",
                                                                children: "Price (low to high)"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "similarproduct-item",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                        children: [
                                                            totalProds,
                                                            " items"
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "similarproduct-mobile-filter",
                                                    onClick: ()=>setOpenMob(true),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                                width: "24",
                                                                height: "24",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: [
                                                                    " ",
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                                                        width: "24",
                                                                        height: "24",
                                                                        fill: "white"
                                                                    }),
                                                                    " ",
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                        "fill-rule": "evenodd",
                                                                        "clip-rule": "evenodd",
                                                                        d: "M8.00039 4.5C8.77359 4.5 9.40039 5.1268 9.40039 5.9C9.40039 6.6732 8.77359 7.3 8.00039 7.3C7.22719 7.3 6.60039 6.6732 6.60039 5.9C6.60039 5.1268 7.22719 4.5 8.00039 4.5ZM10.3483 5.40039C10.1184 4.3147 9.15455 3.5 8.00039 3.5C6.81119 3.5 5.82401 4.36491 5.63357 5.5H4C3.72386 5.5 3.5 5.72386 3.5 6C3.5 6.27614 3.72386 6.5 4 6.5H5.676C5.94243 7.53514 6.88209 8.3 8.00039 8.3C9.15427 8.3 10.118 7.48569 10.3482 6.40039H20.4C20.6761 6.40039 20.9 6.17653 20.9 5.90039C20.9 5.62425 20.6761 5.40039 20.4 5.40039H10.3483ZM8.00039 16.5C8.77359 16.5 9.40039 17.1268 9.40039 17.9C9.40039 18.6732 8.77359 19.3 8.00039 19.3C7.22719 19.3 6.60039 18.6732 6.60039 17.9C6.60039 17.1268 7.22719 16.5 8.00039 16.5ZM8.00039 15.5C9.15455 15.5 10.1184 16.3147 10.3483 17.4004H20.4C20.6761 17.4004 20.9 17.6242 20.9 17.9004C20.9 18.1765 20.6761 18.4004 20.4 18.4004H10.3482C10.118 19.4857 9.15427 20.3 8.00039 20.3C6.88209 20.3 5.94243 19.5351 5.676 18.5H4C3.72386 18.5 3.5 18.2761 3.5 18C3.5 17.7239 3.72386 17.5 4 17.5H5.63357C5.824 16.3649 6.81119 15.5 8.00039 15.5ZM14.5996 11.4996C14.5996 10.7264 15.2264 10.0996 15.9996 10.0996C16.7728 10.0996 17.3996 10.7264 17.3996 11.4996C17.3996 12.2728 16.7728 12.8996 15.9996 12.8996C15.2264 12.8996 14.5996 12.2728 14.5996 11.4996ZM15.9996 9.09961C14.8454 9.09961 13.8816 9.91431 13.6517 11H4C3.72386 11 3.5 11.2239 3.5 11.5C3.5 11.7761 3.72386 12 4 12H13.6518C13.882 13.0853 14.8457 13.8996 15.9996 13.8996C17.1573 13.8996 18.1236 13.0799 18.3496 11.9892C18.3792 11.9963 18.4098 12 18.4412 12H20.5588C20.8025 12 21 11.7761 21 11.5C21 11.2239 20.8025 11 20.5588 11H18.4412C18.4098 11 18.3793 11.0037 18.3498 11.0107C18.124 9.91969 17.1576 9.09961 15.9996 9.09961Z",
                                                                        fill: "#191919"
                                                                    }),
                                                                    " "
                                                                ]
                                                            }),
                                                            " Filter"
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "searchsimilar-prodect-section",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "searchsimilar-prodect-row",
                                                    children: Products.length ? Products.map((prod)=>{
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "searchsimilar-prodect-col",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: prod.productUrl.replace("https://server.orientbell.com/", "/"),
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "searchsimilar-prodect-img",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                            src: prod.imageUrl.length ? prod.imageUrl[0] : ""
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "searchsimilar-prodect-text",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                                                                children: prod.title
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                                children: [
                                                                                    "MRP ₹ ",
                                                                                    convertPricePerSqmToSqft(prod.price),
                                                                                    " /- Sq.ft"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        });
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: "Mo Results Found"
                                                    })
                                                }),
                                                perPage != settotalProds && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "searchsimilar-loar-more-btn",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: "#",
                                                        onClick: (e)=>{
                                                            e.preventDefault();
                                                            loadMore();
                                                        },
                                                        children: "Load More"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (VisualSearch);


/***/ }),

/***/ 29005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_cropper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42016);
/* harmony import */ var cropperjs_dist_cropper_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80113);
/* harmony import */ var cropperjs_dist_cropper_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(cropperjs_dist_cropper_css__WEBPACK_IMPORTED_MODULE_3__);




const ImageCropper = (param)=>{
    let { imgSrc , setImgSrc , setImageCropped  } = param;
    const [image, setImage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(imgSrc);
    const cropperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [showConfirmButton, setShowConfirmButton] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false); // Control visibility of confirm button
    const cropImage = ()=>{
        var ref;
        const cropper = (ref = cropperRef.current) === null || ref === void 0 ? void 0 : ref.cropper;
        if (cropper) {
            const croppedCanvas = cropper.getCroppedCanvas();
            if (croppedCanvas) {
                const url = croppedCanvas.toDataURL(); // Convert canvas to Data URL
                setImgSrc(url); // Pass the cropped image back to the parent
                setImageCropped(true); // Notify parent that the image is cropped
                setShowConfirmButton(false); // Hide the button after crop is confirmed
            }
        }
    };
    const handleCropEnd = ()=>{
        // Show the confirm crop button when cropping ends
        setShowConfirmButton(true);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_cropper__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    style: {
                        height: 400,
                        width: "100%"
                    },
                    initialAspectRatio: 1,
                    aspectRatio: NaN,
                    src: image,
                    ref: cropperRef,
                    viewMode: 1,
                    guides: false,
                    cropend: handleCropEnd
                }),
                showConfirmButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "confirm-crop-btn",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: cropImage,
                        style: {
                            padding: "10px 20px",
                            cursor: "pointer"
                        },
                        children: "Confirm Crop"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageCropper);


/***/ }),

/***/ 93115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83346);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6154);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31955);
/* harmony import */ var _components_visualSearch__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32147);
/* provided dependency */ var Buffer = __webpack_require__(48764)["lW"];










const ProductCard = (props)=>{
    let [mrp, setMrp] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(props.product.extraVariables.sq_ft_price);
    let [sellingPrice, seSellingPrice] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0);
    let [outOfStock, setOutOfStock] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("Add to cart");
    const [AvailableStock, setAvailableStock] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0);
    let [similerr, setSimilerr] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [base64content, setbase64content] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const getBestPrice = async (pin)=>{
        var ref, ref1, ref2, ref3;
        let apiresult = await axios__WEBPACK_IMPORTED_MODULE_6__/* ["default"].get */ .Z.get("https://obl-js.orientbell.com/api/product-availability-dev?sku=".concat(props.product.sku, "&pincode=").concat(pin, "&factory=").concat(props.product.extraVariables.factory));
        if (((ref = apiresult.data) === null || ref === void 0 ? void 0 : (ref1 = ref.Plants) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
            var ref4, ref5, ref6, ref7;
            let temparr = [];
            if ((ref4 = apiresult.data) === null || ref4 === void 0 ? void 0 : ref4.Plants.includes("Sikandrabad Plant")) {
                var ref8, ref9;
                temparr.push(Number((ref8 = apiresult.data) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.erpStock) === null || ref9 === void 0 ? void 0 : ref9.skd_stock));
            }
            if ((ref5 = apiresult.data) === null || ref5 === void 0 ? void 0 : ref5.Plants.includes("Dora Plant")) {
                var ref10, ref11;
                temparr.push(Number((ref10 = apiresult.data) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.erpStock) === null || ref11 === void 0 ? void 0 : ref11.dora_stock));
            }
            if ((ref6 = apiresult.data) === null || ref6 === void 0 ? void 0 : ref6.Plants.includes("Hoskote Plant")) {
                var ref12, ref13;
                temparr.push(Number((ref12 = apiresult.data) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.erpStock) === null || ref13 === void 0 ? void 0 : ref13.hoskote_stock));
            }
            if ((ref7 = apiresult.data) === null || ref7 === void 0 ? void 0 : ref7.Plants.includes("West Zone")) {
                var ref14, ref15;
                temparr.push(Number((ref14 = apiresult.data) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.erpStock) === null || ref15 === void 0 ? void 0 : ref15.west_zone_stock));
            }
            setAvailableStock(temparr.reduce((total, obj)=>total + obj, 0));
            console.log("STOCKKKKKKKKKKK ", temparr.reduce((total, obj)=>total + obj, 0));
        }
        if (((ref2 = apiresult.data) === null || ref2 === void 0 ? void 0 : ref2.transportOrder) == 0) {
            return;
        } else if ((ref3 = apiresult.data) === null || ref3 === void 0 ? void 0 : ref3.devliverytime) {
            var ref16;
            if ((ref16 = apiresult.data) === null || ref16 === void 0 ? void 0 : ref16.updated_price_ft) {
                var ref17;
                seSellingPrice((ref17 = apiresult.data) === null || ref17 === void 0 ? void 0 : ref17.updated_price_ft);
            }
        } else if (1 > apiresult.data.availableQty) {
            setOutOfStock("Out of Stock");
        } else if (apiresult.data.addesses == "" || !apiresult.data.devliverytime) {
            setOutOfStock("Not Deliverable");
        //trackProductUnavailability(props.product.sku, pin)
        }
    };
    async function convertImageToBase64(url) {
        console.log("Original URL: ", url);
        // Replace 'obl-new' with 'images' in the URL
        url = url.replace("obl-new", "images");
        console.log("Updated URL: ", url);
        try {
            // Fetch the image as an arraybuffer
            const response = await axios__WEBPACK_IMPORTED_MODULE_6__/* ["default"].get */ .Z.get(url, {
                responseType: "arraybuffer"
            });
            // Convert the response data (binary) to a buffer
            const buffer = Buffer.from(response.data, "binary");
            // Convert the buffer to a Base64 string
            const base64String = buffer.toString("base64");
            console.log("Base64 Encoded Image: ", base64String);
            // Return the Base64 string
            return base64String;
        } catch (error) {
            console.error("Error fetching or converting image to Base64: ", error);
            throw error;
        }
    }
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        console.log(props.product);
        setAvailableStock(props.product.stock ? props.product.stock : [
            Number(props.product.extraVariables.skd_stock),
            Number(props.product.extraVariables.dora_stock),
            Number(props.product.extraVariables.hoskote_stock),
            Number(props.product.extraVariables.west_zone_stock)
        ].reduce((total, obj)=>total + obj, 0));
        if (props.pinFromCityPage) {
            getBestPrice(props.pinFromCityPage);
        } else if (js_cookie__WEBPACK_IMPORTED_MODULE_4__/* ["default"].get */ .Z.get("pincode")) {
            getBestPrice(js_cookie__WEBPACK_IMPORTED_MODULE_4__/* ["default"].get */ .Z.get("pincode"));
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            base64content && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_visualSearch__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                base64: base64content,
                setbase64content: setbase64content
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "product-listing-col unbxd-result-tile",
                id: props.product.sku,
                children: [
                    props.product.extraVariables.is_new && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        id: "newicon",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: "/New-Strip-icon.png"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "cate-pro-figure",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "".concat(_config__WEBPACK_IMPORTED_MODULE_3__/* ["default"].HEADLESS_BASE_URL */ .Z.HEADLESS_BASE_URL, "/").concat(props.product.url_key),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: props.isAmbience ? props.product.extraVariables.ambience_image_url : props.product.extraVariables.image_url,
                                    width: 265.67,
                                    height: 265.67,
                                    alt: props.product.name,
                                    loading: "lazy"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "cam-bx",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "/compare_1.webp",
                                    onClick: ()=>props.addProductToComapre(props.product.id),
                                    loading: "lazy",
                                    alt: "Compare Logo"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "cate-pro-text",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "produ-view",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        // id="findsimilarlisting"
                                        className: "syte-discovery",
                                        // data-sku={props.product.sku}
                                        // data-image-src={
                                        //   props.product.extraVariables.image_url
                                        // }
                                        "data-placement": "PLP",
                                        onClick: async ()=>{
                                            let img = await convertImageToBase64(props.product.extraVariables.image_url ? props.product.extraVariables.image_url : "");
                                            setbase64content(img);
                                        // setSimilerr(props.product?.imageUrl?.length ? props.product.imageUrl[0] : "")
                                        },
                                        children: "Find Similar"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "roomvo-container",
                                        "data-product-type-str": "",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            className: "roomvo-stimr some-class",
                                            "data-sku": props.product.sku,
                                            style: {
                                                "visibility": "hidden"
                                            },
                                            children: "Try in my room"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "simi-name",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "".concat(_config__WEBPACK_IMPORTED_MODULE_3__/* ["default"].HEADLESS_BASE_URL */ .Z.HEADLESS_BASE_URL, "/").concat(props.product.url_key),
                                    children: props.product.name
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "produ-price",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    children: [
                                        sellingPrice && Number(mrp) > Number(sellingPrice) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                            className: "mrp",
                                            children: [
                                                "Offer price ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                    children: "₹."
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                    style: {
                                                        textDecoration: "line-through",
                                                        marginRight: "5px"
                                                    },
                                                    children: [
                                                        " ",
                                                        Math.round(mrp),
                                                        " "
                                                    ]
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("strong", {
                                                    children: [
                                                        " ",
                                                        Math.round(sellingPrice),
                                                        " /- Sq.ft "
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                            className: "mrp",
                                            children: [
                                                "MRP ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("strong", {
                                                    children: [
                                                        " ₹ ",
                                                        Math.round(mrp),
                                                        " /- Sq.ft"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            className: "best-pri",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: "".concat(_config__WEBPACK_IMPORTED_MODULE_3__/* ["default"].HEADLESS_BASE_URL */ .Z.HEADLESS_BASE_URL, "/").concat(props.product.url_key),
                                                className: "buy-now-btn",
                                                children: "Buy Now"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "produ-size",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "produ-size-leftbox",
                                        children: [
                                            "Size ",
                                            props.product.extraVariables.tile_size
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "produ-size-rightbox",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                style: {
                                                    display: "inline-block",
                                                    width: "10px",
                                                    height: "10px",
                                                    borderRadius: "50%",
                                                    backgroundColor: AvailableStock > 0 && AvailableStock <= 100 ? "red" : AvailableStock > 100 && AvailableStock <= 250 ? "orange" : AvailableStock > 250 && AvailableStock <= 1000 ? "lightgreen" : AvailableStock > 1000 ? "darkgreen" : "grey",
                                                    marginRight: "5px"
                                                }
                                            }),
                                            AvailableStock > 0 && AvailableStock <= 100 ? "Out of Stock" : AvailableStock > 100 && AvailableStock <= 250 ? "Low Stock" : AvailableStock > 250 && AvailableStock <= 1000 ? "Limited Stock" : AvailableStock > 1000 ? "In Stock" : "Out of Stock",
                                            " "
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "add-button",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "".concat(_config__WEBPACK_IMPORTED_MODULE_3__/* ["default"].HEADLESS_BASE_URL */ .Z.HEADLESS_BASE_URL, "/").concat(props.product.url_key),
                                    className: "add-pro-btn",
                                    style: {
                                        backgroundColor: outOfStock == "Not Deliverable" ? "#a5a5a5" : outOfStock == "Out of Stock" ? "#ffcb08" : "#0b9444"
                                    },
                                    children: outOfStock
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductCard);


/***/ })

}]);